import { Link } from "react-router-dom";
import { User, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CartDrawer } from "@/components/cart/CartDrawer";
import { SearchDialog } from "@/components/search/SearchDialog";

interface HeaderIconsProps {
  isLoggedIn: boolean;
  totalWishlistCount: number;
  th: (key: string, fallback: string) => string;
}

export const HeaderIconsDesktop = ({ isLoggedIn, totalWishlistCount, th }: HeaderIconsProps) => (
  <div className="hidden lg:flex items-center gap-1">
    <Button variant="ghost" size="icon" className="hover:bg-transparent" asChild>
      <Link
        to={isLoggedIn ? "/profile" : "/auth"}
        aria-label={isLoggedIn ? th("personalArea", "האזור האישי") : th("login", "התחברות")}
      >
        <User className="h-5 w-5 text-primary" strokeWidth={1.5} />
      </Link>
    </Button>
    <Button variant="ghost" size="icon" className="hover:bg-transparent relative" asChild>
      <Link to="/wishlist" aria-label={th("wishlist", "רשימת המועדפים")}>
        <Heart className="h-5 w-5 text-primary" strokeWidth={1.5} />
        {totalWishlistCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center">
            {totalWishlistCount}
          </span>
        )}
      </Link>
    </Button>
    <SearchDialog />
    <CartDrawer />
  </div>
);

export const HeaderIconsMobileRight = ({ isLoggedIn, totalWishlistCount, th }: HeaderIconsProps) => (
  <div className="flex lg:hidden items-center gap-1">
    <Button variant="ghost" size="icon" className="hover:bg-transparent relative" asChild>
      <Link to="/wishlist" aria-label={th("wishlist", "רשימת המועדפים")}>
        <Heart className="h-5 w-5 text-primary" strokeWidth={1.5} />
        {totalWishlistCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center">
            {totalWishlistCount}
          </span>
        )}
      </Link>
    </Button>
    <CartDrawer />
  </div>
);
